export const PERMISSIONS = {
  BOOKING: {
    CREATE: 'BOOKING_REQUEST',
    EDIT: 'EDIT_BOOKING',
    CANCEL: 'CANCEL_BOOKING',
  },
  PRECONFIRM_BOOKING: {
    CREATE: 'PRE_CONFIRM_BOOKING',
  },
  CIRCUIT_BOOKING: {
    CREATE: 'CIRCUIT_BOOKING',
  },
  CALENDAR: {
    VIEW: 'CALENDAR'
  },
  BOOKING_HISTORY: {
    VIEW: 'BOOKING_HISTORY',
  },
  PAYROLL_REPORT: {
    VIEW: 'PAYROLL_REPORT',
  },
  INSIGHTS: {
    VIEW: 'INSIGHTS',
  },
  MY_LIST: {
    VIEW: 'MY_LIST',
    COMPATIBLE_ACTION:'COMPATIBLE_ACTION'
  },
  SMART_GROUPS: {
    VIEW: 'SMART_GROUP',
  },
  FIND_NEW_TEACHER: {
    VIEW: 'FIND_NEW_TEACHER',
  },
  BOOKING_CONFIRMATION: {
    CREATE: 'BOOKING_CONFIRMATION',
  },
  INVITE: {
    VIEW: 'INVITE',
  },
  REQUEST: {
    VIEW: 'REQUEST',
  },
  HUB_AND_SPOKE: {
    VIEW: 'HUB_AND_SPOKE',
  },
  SCHOOL_PROFILE: {
    VIEW: 'SCHOOL_PROFILE',
    EDIT: 'SCHOOL_PROFILE_WRITE',
  },
  MANAGE_TEAM: {
    VIEW: 'MANAGE_TEAM',
    EDIT: 'MANAGE_TEAM',
  },
  EDIT_BOOKING: {
    EDIT: 'EDIT_BOOKING',
  },
  NOTE_ACTIONS: {
    EDIT: 'NOTE_ACTION',
  },
  MY_LIST_ACTION: {
    EDIT: 'MY_LIST_ACTION',
  },
  CANCEL_BOOKING: {
    EDIT: 'CANCEL_BOOKING',
  },

} as const; 
